import UserService from '@services/user-service'
import { getSavedState, saveState } from '@utils/user-info.js'

let mainPageAsCard = getSavedState('user.mainPageAsCard');

export const state = {
    user: {},
    mainPageAsCard: mainPageAsCard === null || mainPageAsCard,
}

export const mutations = {
    SET_PROFILE(state, user) {
        state.user = user
    },
    SET_MAIN_PAGE_AS_CARD(state, value) {
        state.mainPageAsCard = value;
        saveState('user.mainPageAsCard', value)
    }
}

export const getters = {
    user(state) {
        return state.user
    },
    mainPageAsCard(state) {
        return state.mainPageAsCard
    },
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    async init({ dispatch }) {
        if (getSavedState('auth.userUuid')) {
            dispatch('getProfile')
        }
    },

    setProfile({ commit }, payload) {
        commit('SET_PROFILE', payload)
    },

    async getProfile({ dispatch }) {
        const profile = await UserService.getUserInfo({
            userUuid: getSavedState('auth.userUuid'),
        })

        dispatch('setProfile', profile)
    },

    setMainPageAsCard({ commit }, payload) {
        commit('SET_MAIN_PAGE_AS_CARD', payload)
    }
}
